// import { Icon as VoltoIcon } from '@plone/volto/components';
// import { Icon } from '@package/icons';

// import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
// import checkSVG from '@plone/volto/icons/check.svg';

import { defineMessages } from 'react-intl';

// import * as featherIcons from '@package/icons/assets';

const messages = defineMessages({
  numbers: { id: 'Numbers', defaultMessage: 'Numbers' },
  statNum: { id: 'Stat {id}', defaultMessage: 'Stat {id}' },
  value: { id: 'Value', defaultMessage: 'Value' },
  description: { id: 'Description', defaultMessage: 'Description' },
  category: { id: 'Category', defaultMessage: 'Category' },
  // icon: { id: 'Icon', defaultMessage: 'Icon' },
  // typeToSearch: {
  //   id: 'Type to search…',
  //   defaultMessage: 'Type to search…',
  // },
  // iconStyle: { id: 'Icon style', defaultMessage: 'Icon style' },
  // lightBlueDarkBlue: {
  //   id: 'Light blue / Dark blue',
  //   defaultMessage: 'Light blue / Dark blue',
  // },
  // yellowDarkBlue: {
  //   id: 'Yellow / Dark blue',
  //   defaultMessage: 'Yellow / Dark blue',
  // },
  // greenDarkBlue: {
  //   id: 'Green / Dark blue',
  //   defaultMessage: 'Green / Dark blue',
  // },
  // darkBlueWhite: {
  //   id: 'Dark blue / White',
  //   defaultMessage: 'Dark blue / White',
  // },
  // redWhite: { id: 'Red / White', defaultMessage: 'Red / White' },
  // transparentDarkBlue: {
  //   id: 'Transparent / Dark blue',
  //   defaultMessage: 'Transparent / Dark blue',
  // },
  // transparentLightBlue: {
  //   id: 'Transparent / Light blue',
  //   defaultMessage: 'Transparent / Light blue',
  // },
});

// const colors = (intl) => [
//   {
//     name: 'icon-light-blue-dark-blue',
//     label: intl.formatMessage(messages.lightBlueDarkBlue),
//   },
//   {
//     name: 'icon-yellow-dark-blue',
//     label: intl.formatMessage(messages.yellowDarkBlue),
//   },
//   {
//     name: 'icon-green-dark-blue',
//     label: intl.formatMessage(messages.greenDarkBlue),
//   },
//   {
//     name: 'icon-dark-blue-white',
//     label: intl.formatMessage(messages.darkBlueWhite),
//   },
//   { name: 'icon-red-white', label: intl.formatMessage(messages.redWhite) },
//   {
//     name: 'icon-transparent-dark-blue',
//     label: intl.formatMessage(messages.transparentDarkBlue),
//   },
//   {
//     name: 'icon-transparent-light-blue',
//     label: intl.formatMessage(messages.transparentLightBlue),
//   },
// ];

// const IconItem = injectLazyLibs('reactSelect')((props) => {
//   const { Option } = props.reactSelect.components;

//   return (
//     <Option {...props}>
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <Icon icon={props.value} />
//         <span style={{ marginLeft: 8 }}>{props.label}</span>
//       </div>
//       {props.isFocused && !props.isSelected && (
//         <VoltoIcon name={checkSVG} size="24px" color="#b8c6c8" />
//       )}
//       {props.isSelected && (
//         <VoltoIcon name={checkSVG} size="24px" color="#007bc1" />
//       )}
//     </Option>
//   );
// });

const statProperties = (id, intl) => {
  return {
    [`value${id}`]: {
      title: intl.formatMessage(messages.value),
      // description: intl.formatMessage(messages.statValueDescription),
    },
    [`description${id}`]: {
      title: intl.formatMessage(messages.description),
    },
    [`category${id}`]: {
      title: intl.formatMessage(messages.category),
    },
    // [`icon${id}`]: {
    //   title: intl.formatMessage(messages.icon),
    //   placeholder: intl.formatMessage(messages.typeToSearch),
    //   noValueOption: false,
    //   isMulti: false,
    //   choices: Object.keys(featherIcons).map((icon) => [icon, icon]),
    //   customOptionStyling: IconItem,
    // },
    // [`style${id}`]: {
    //   title: intl.formatMessage(messages.iconStyle),
    //   widget: 'color_picker',
    //   colors: colors(intl),
    // },
  };
};

const statFieldset = (id, intl) => {
  return {
    id: `stat${id}`,
    title: intl.formatMessage(messages.statNum, { id }),
    fields: [
      `value${id}`,
      `category${id}`,
      `description${id}`,
      // `icon${id}`,
      // `style${id}`,
    ],
  };
};

export const numbersSchema = ({ intl }) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.numbers),
        fields: [],
      },
      statFieldset(1, intl),
      statFieldset(2, intl),
      statFieldset(3, intl),
    ],
    properties: {
      ...statProperties(1, intl),
      ...statProperties(2, intl),
      ...statProperties(3, intl),
    },
    required: [],
  };
};
